import { Component, Input, OnInit } from '@angular/core';
import { SweetAlert } from 'sweetalert/typings/core';
import { CommonGalleryDialogComponent } from '../common-gallery-dialog/common-gallery-dialog.component';
import { DeleteDialogComponent } from '../delete-dialog/delete-dialog.component';
// import { DeleteDialogComponent } from '../delete-dialog/delete-dialog.component';
const Swal: SweetAlert = require('sweetalert');

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {

  @Input() addButtonName: string = 'New Loan Application';
  @Input() pageName: string = 'Loan Applications'
  @Input() isPagination: boolean = true;
  @Input() pagination: any;
  @Input() publishButton: boolean = false;
  @Input() tableHeader: any;
  @Input() masterData: any;
  @Input() isDownloadButtonShow: boolean = true;

  openWithdrawDialogue: boolean = false;


 totalCount = 100;
  page = 10;
  dialog: any;

  constructor() {}

  ngOnInit(): void {
    
  }

  submitData(event: any) {

  }

  getMasterData() {

  }

  editData(rowData: any, isEdit: any = true) {

  }

  setApprove(event: any, rowData: any) {
    rowData.checked = !rowData.checked;
  }

  approveReject(isApproved: any = 1) {

  }

  pageEvent(event: any) {

  }

  openDeleteDialog(data: any) {

  }

  openDialog(fileList: any) {
    const dialogRef = this.dialog.open(CommonGalleryDialogComponent, {
      data: {
        fileList: fileList,
      },
      width: '800px',
      height: 'auto',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      // console.log(`Dialog result: ${result}`);
    });
  }

  addCore() {
  }

  checkAvailablitiy(endPoint: string) {
    return true;
  }

  downloadCsvButton() {}

  // openDeleteDialog(data: any) {
  //   const dialogRef = this.dialog.open(DeleteDialogComponent);
  //   dialogRef.afterClosed().subscribe((result: any) => {
  //     if (result) {
  //       this.deleteContent(data)
  //     }
  //   });
  // }

}
